import React, {Component} from 'react';
import PropTypes from 'prop-types';
import HeaderRow from './rows/HeaderRow';
import SiteRow from './rows/SiteRow';
import ReservationRow from './rows/ReservationRow';
import UserRow from './rows/UserRow';
import MobileUserRow from './rows/MobileUserRow';
import DeveloperRow from './rows/DeveloperRow';
import LogRow from './rows/LogRow';
import SpecialAreaRow from './rows/SpecialAreaRow';
import PermissionsRow from './rows/PermissionsRow';
import MaxAllowedDevicesRow from './rows/MaxAllowedDevicesRow';
import WirelessConfigRow from './rows/WirelessConfigRow';

class PermissionsMatrix extends Component {
  constructor(props) {
    super(props);

    this.getPermissionSection = this.getPermissionSection.bind(this);
  }

  getPermissionSection(permissionSectionName) {
    return this.props.permissionSections ? this.props.permissionSections.find((section) => section.section === permissionSectionName) : null;
  }

  render() {
    return (
      <div className="table-container">
        <HeaderRow />
        <SiteRow permissionSection={this.getPermissionSection('Site')} onChange={this.props.onChange} />
        <ReservationRow permissionSection={this.getPermissionSection('Reservation')} onChange={this.props.onChange} />
        <UserRow permissionSection={this.getPermissionSection('User')} onChange={this.props.onChange} />
        <MobileUserRow permissionSection={this.getPermissionSection('Mobile User')} onChange={this.props.onChange} />
        <DeveloperRow permissionSection={this.getPermissionSection('Developer')} onChange={this.props.onChange} />
        <LogRow permissionSection={this.getPermissionSection('Log')} onChange={this.props.onChange} />
        <SpecialAreaRow permissionSection={this.getPermissionSection('Special Area')} onChange={this.props.onChange} />
        <PermissionsRow permissionSection={this.getPermissionSection('Permissions')} onChange={this.props.onChange} />
        <MaxAllowedDevicesRow permissionSection={this.getPermissionSection('Max Allowed Devices')} onChange={this.props.onChange} />
        <WirelessConfigRow permissionSection={this.getPermissionSection('Wireless Config')} onChange={this.props.onChange} />
      </div>
    );
  }
}

PermissionsMatrix.propTypes = {
  permissionSections: PropTypes.array,
  user: PropTypes.object,
  onChange: PropTypes.func,
};

export default PermissionsMatrix;
